<!--
  DistributorLink -- the ONE way SA surfaces show a distributor NAME.

  Renders the name as a real <a href> (router-link) to /admin/distributors/:id,
  so middle-click / open-in-new-tab work. That route redirects to the edit page
  today (router/groups/superadmin.js); link to the bare route so the target
  follows whenever a read-only page replaces the redirect.

  No id (a payload that carries only a name) renders plain text: we never
  guess a link target. Click does not bubble, so a link inside a clickable
  table row does not also fire the row's handler.
-->
<template>
    <router-link
        v-if="distributorId != null && distributorId !== ''"
        :to="`/admin/distributors/${distributorId}`"
        class="sa-link"
        :data-testid="`distributor-link-${distributorId}`"
        @click.stop
    >
        {{ label }}
    </router-link>
    <span v-else>{{ label }}</span>
</template>

<script>
export default {
    name: "DistributorLink",
    props: {
        distributorId: { type: [Number, String], default: null },
        name: { type: String, default: "" },
        // Shown when `name` is empty (e.g. "Distributor #3", "--").
        fallback: { type: String, default: "" },
    },
    computed: {
        label() {
            return this.name || this.fallback;
        },
    },
};
</script>
